<template>

    <div class="popup-form">
        <v-card>
            <v-snackbar v-model="snackbar" color="success" :timeout="servicesData.timeout" top>
                {{servicesData.message}}
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-toolbar class="toolbar-header-color">
                <v-toolbar-title>
                    {{$t('download_manual')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="dialogueClose">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <form>
                        <v-row>
                            <v-col cols="12"
                                   sm="6"
                                   md="6"
                                   xl="6"
                                   v-for="(manual,index) in manualList" v-bind:key="index"
                                   class="viewCard">
                                <v-btn class="download-btn w-100"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="downloadFile(manual)"
                                       target="_blank">
                                    <v-icon left>mdi-cloud-download</v-icon>
                                    {{ manual.manualType === '.pdf' ? $t('download_pdf') : $t('download_video') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </v-container>
            </v-card-text>
        </v-card>
    </div>

</template>


<script>
    import { mapGetters } from "vuex";
    import axios from "axios";
    export default {
        data() {
            return {
                snackbar: false,
                manualList: [],
                servicesData: {
                    data: {},
                    message: "",
                    color: "",
                    timeout: 4000
                }
            };
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            isBranch() {
                return this.userRole === "Branch"
            },
            isDepo() {
                return this.userRole === "Depo"
            },
        },
        methods: {
            getlist() {
                axios.get('Upload/GetUserManualList').then(response => {
                    this.manualList = response.data
                })
            },
            downloadFile(manual) {
                if (manual.manualType === '.pdf') {
                    window.open(manual.manualFile, '_blank');
                } else {
                    const link = document.createElement('a');
                    link.href = manual.manualFile;
                    link.download = manual.manualID;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            },
            dialogueClose() {

                this.$emit("formResponse", this.servicesData);
            },
            
        },
        created() {
            this.getlist()
        }
    }
</script>

<style scoped>
    .popup-form {
    }
</style>